/* eslint-disable @next/next/no-img-element */
import React, { FC, useState, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, {
  SwiperOptions,
  Zoom,
  Autoplay,
  Lazy,
  Keyboard,
} from 'swiper'
import Dialog from '@mui/material/Dialog'
import 'swiper/css'
// import { isPC } from '../utils/checkDevice'
// import { useWindowSize } from '../hooks/useWindowSize'

SwiperCore.use([Zoom, Autoplay, Lazy, Keyboard])
// import Image from './Image'
const photoSwiperConfig: SwiperOptions = {
  autoplay: false,
  loop: true,
  zoom: true,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 3,
  },
  centeredSlides: true,
  observer: true,
  spaceBetween: 0,
}

interface Props {
  images: string[]
  open?: boolean
  initialSlide?: number
  showPagination?: boolean
  className?: string
  onOpenChange?: (e?: boolean) => any
  onSlideChange?: (e: number) => any
  [key: string]: any
}
const PhotoSwiper: FC<Props> = ({
  images,
  open = false,
  initialSlide = 1,
  className = '',
  onOpenChange,
  onSlideChange,
  showPagination = true,
  ...others
}) => {
  const config = {
    ...photoSwiperConfig,
    ...others,
  }
  const { lazy, zoom } = config
  // const ispc = useMemo(() => isPC(), [])
  // const { upSm } = useWindowSize()
  const position = useRef<any>({})
  const count = useRef(0)
  const [swiperIndex, setSwiperIndex] = useState<number>(initialSlide)
  const handleSlideChange = (e: any) => {
    setSwiperIndex(e.realIndex)
    onSlideChange?.(e.realIndex)
  }
  // swiper移动端不返回events，伐了
  const handleTouchStart = (ev: any) => {
    position.current = {
      ev,
    }
  }
  const handleTouchEnd = (ev: any) => {
    const { clientX, clientY } = position.current.ev
    const { clientX: clientX2, clientY: clientY2 } = ev
    count.current += 1
    setTimeout(() => {
      if (
        count.current === 1 &&
        Math.abs(clientX - clientX2) < 10 &&
        Math.abs(clientY - clientY2) < 10
      ) {
        onOpenChange?.(false)
      }
      count.current = 0
      window.document.body.style.pointerEvents = 'none'
      setTimeout(
        // eslint-disable-next-line no-return-assign
        () => (window.document.body.style.pointerEvents = 'unset'),
        300
      )
    }, 300)
  }
  return (
    <>
      <Dialog className="photo-wrapper-box" open={open} fullScreen>
        <div
          className={`photo-wrapper absolute top-0 left-0 z-10 w-full h-full flex justify-center items-center bg-black ${className}`}
        >
          <Swiper
            {...config}
            initialSlide={initialSlide}
            keyboard={{
              enabled: true,
            }}
            onSlideChange={handleSlideChange}
            onPointerDown={(ev) => handleTouchStart(ev)}
            onPointerUp={(ev) => handleTouchEnd(ev)}
            className="w-full"
          >
            {images.map((item: string) => (
              <SwiperSlide key={item} className="w-full h-screen">
                <div
                  className={`flex w-full justify-center items-center h-screen relative ${
                    zoom ? 'swiper-zoom-container' : ''
                  }`}
                  style={{
                    height: '100vh',
                  }}
                  onPointerDown={(e) => handleTouchStart(e.nativeEvent)}
                  onPointerUp={(e) => handleTouchEnd(e.nativeEvent)}
                >
                  <img
                    className={`block border-none w-full ${
                      lazy ? 'swiper-lazy' : ''
                    }`}
                    data-src={item}
                    src={!lazy ? item : ''}
                    height="auto"
                    style={{
                      maxWidth: '580px',
                    }}
                    alt=""
                  />
                  {lazy && (
                    <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                  )}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          {showPagination && (
            <div className="photo-text absolute bottom-0 z-20 flex justify-center text-white mb-11 textShadow">
              {swiperIndex + 1} / {images.length}
            </div>
          )}
        </div>
      </Dialog>
      <style jsx>{`
        .textShadow {
          text-shadow: 0px 6px 8px rgba(0, 0, 0, 0.48);
        }
      `}</style>
    </>
  )
}

export default PhotoSwiper
